import React from 'react';
import { Row, Col } from 'antd';
import { Info, AlertOctagon, AlertTriangle, ArrowRight } from 'react-feather';
import { Link } from "react-router-dom";

export const CaptionType = {
    Information: 0,
    Warning: 1,
    Error: 2
}

const CaptionComponent = ({
    className,
    textColor,
    text,
    link,
    openNewTab = false,
    linktext,
    status = CaptionType.Information,
    isBold
}) => {
    const iconColor = status === CaptionType.Error
        ? '#9B2020'
        : status === CaptionType.Warning
            ? '#F3983B'
            : '#005888';

    const containerStyleBackgroundColor = status === CaptionType.Error
        ? 'rgba(155, 32, 32, 0.1)'
        : status === CaptionType.Warning
            ? 'rgba(243, 152, 59, 0.1)'
            : 'rgba(0, 88, 136, 0.1)'

    const containerStyle = {
        borderRadius: '10px',
        border: `1px solid ${iconColor}`,
        background: containerStyleBackgroundColor,
        padding: '5px 8px',
        alignItems: 'center',
        gap: '16px'
    };

    const iconStyle = {
        color: iconColor,
        width: '16px',
        height: '16px',
    };

    const textStyle = {
        fontWeight: isBold ? 'bold' : 'normal',
        color: textColor,
    };

    const linkStyle = {
        textDecoration: "underline",
        color: textColor,
        marginRight: "8px",
        cursor: "pointer"
    };

    return (
        <Row style={containerStyle} className={`${className}`}>
            {status === CaptionType.Error ?
                <AlertTriangle style={iconStyle} />
                : status === CaptionType.Warning ?
                    <AlertOctagon style={iconStyle} />
                    : <Info style={iconStyle} />
            }
            {linktext ? (
                <Col>
                    <Row gutter={12}>
                        <span style={textStyle}>
                            {text}
                        </span>
                    </Row>
                    <Row gutter={12} align="middle">
                        <Link style={linkStyle} to={link} target={openNewTab ? "_blank" : ""}>
                            {linktext}
                        </Link>
                        <ArrowRight width={16} height={16} />
                    </Row>
                </Col>
            ) : (
                <span style={textStyle}>
                    &nbsp;{text}
                </span>
            )}
        </Row>
    );
};

export default CaptionComponent;
